import React from 'react';
import PropTypes from 'prop-types';

// Component Styles
import './slider.scss';

/**
 * It displays a Slider component
  * @extends {Component}
 */
class Slider extends React.Component {
  constructor(props) {
    super(props);

    /**
     * Component initial state.
     * @type {Object}
     * @property {String} inputText It handles the state of the slider.
     *                              It will take the default value from the prop value.
     */
    this.state = {
      sliderValue: this.props.value,
    };

    // Context binding for function.
    this.updateSliderValueState = this.updateSliderValueState.bind(this);
    this.onSliderChange = this.onSliderChange.bind(this);
  }

  /**
   * After an update occurs, it will check if the value prop is different from the previous
   * slider prop value. If this prop differs the state of the slider value it will change.
   * @param {Object} prevProps
   */
  componentDidUpdate(prevProps) {
    const sliderValue = this.props.value;

    if (sliderValue !== prevProps.value) {
      this.updateSliderValueState(sliderValue);
    }
  }

  /**
   * This method is executed on the slide onChange callback. It will execute the parent callback and the
   * internal setState for its value.
   * @param {Object} event slider onChange event.
   */
  onSliderChange(event) {
    this.props.onSliderChange(event.target.value);

    this.setState({
      sliderValue: event.target.value,
    });
  }

  /**
   * This method updates the `sliderValue` state.
   * @param {String} sliderValue it contains the current slider value.
   */
  updateSliderValueState(sliderValue) {
    this.setState({
      sliderValue,
    });
  }

  render() {
    return (
      <input
        value={this.state.sliderValue}
        className='wtfSlider'
        type='range'
        min={this.props.minRange}
        max={this.props.maxRange}
        onMouseLeave={event => this.props.onSliderMouseLeave(event.target.value)}
        onChange={this.onSliderChange}
      />
    );
  }
}


/**
 * Set the Slider component props default values.
 * @type {Object}
 * @property {String}   value              The value of the slider.
 * @property {String}   minRange           The minimum range of the slider.
 * @property {String}   maxRange           The maximum range of the slider.
 * @property {Function} onSliderChange     Callback that is executed when the slider change its value.
 * @property {Function} onSliderMouseLeave Callback that is executed on slider mouse leave.
 */
Slider.defaultProps = {
  value: '',
  minRange: '1',
  maxRange: '100',
  onSliderChange: () => {},
  onSliderMouseLeave: () => {},
};

/**
 * Declare the Slider component PropTypes for better validation.
 * @type {Object}
 */
Slider.propTypes = {
  value: PropTypes.string,
  minRange: PropTypes.string,
  maxRange: PropTypes.string,
  onSliderChange: PropTypes.func,
  onSliderMouseLeave: PropTypes.func,
};

export default Slider;



// WEBPACK FOOTER //
// ./node_modules/myfonts-font-preview-toolbar/src/components/common/Slider/Slider.js